import type { CanonicalMeasurement, MeasurementLabel } from '@/models/template';
import rowStyles from '@/features/report/Measurements/Row/MeasurementRow.module.css';
import editableRowStyles from './EditableMeasurementRow/EditableMeasurementRow.module.css';
import styles from './EditableMeasurementsSection.module.css';

interface DragPreviewRowProps {
  measurementLabel: MeasurementLabel;
  canonicalMeasurementsByKey: Map<string, CanonicalMeasurement>;
}

/**
 * Static visual snapshot of a measurement row, rendered inside DragOverlay
 * so it follows the cursor while the source row stays put as a placeholder.
 */
export function DragPreviewRow({
  measurementLabel,
  canonicalMeasurementsByKey,
}: DragPreviewRowProps) {
  const canonicalMeasurement = measurementLabel.canonicalMeasurementKey
    ? canonicalMeasurementsByKey.get(measurementLabel.canonicalMeasurementKey)
    : undefined;
  return (
    <div className={`${editableRowStyles.row} ${styles.dragPreview}`}>
      <span className={`${rowStyles.label} ${editableRowStyles.labelCell}`}>
        {measurementLabel.label || (
          <span className={styles.placeholderText}>Label</span>
        )}
      </span>
      <span className={editableRowStyles.pickerCell}>
        <span className={styles.dragPreviewValue}>
          {canonicalMeasurement?.abbreviation ?? '—'}
        </span>
      </span>
      <span className={rowStyles.unit}>{measurementLabel.unit ?? ''}</span>
    </div>
  );
}
